import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';

import { Divider } from 'legacyComponents/styled/lib';

import { Follow } from 'apps/content/views/follow';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';
import {
  ProfileWrapper as InitiativeWrapper,
  ProfileAvatar as IniAvatar,
  Title,
  Bio,
  FollowButtonWrapper,
} from 'apps/modals/connResultsModal/styles';

@observer
export class InitiativeListItem extends React.Component {
  render() {
    const { initiative } = this.props;
    const { id, slug, avatar, title, description, content } = initiative;
    return (
      <div key={id}>
        <InitiativeWrapper>
          <Link
            name='initiative'
            params={{ initiative: slug }}
            content={content}
          >
            <IniAvatar
              src={imageSrc(
                avatar,
                initiative.imageFallbackPath,
                mainConf.imgSizes.profile.large,
              )}
            />
          </Link>
          <Link
            name='initiative'
            params={{ initiative: initiative.slug }}
            content={content}
          >
            <Title>{title}</Title>
          </Link>
          <Bio>{description}</Bio>
          <FollowButtonWrapper>
            <Follow content={initiative.content} small />
          </FollowButtonWrapper>
        </InitiativeWrapper>
        <Divider />
      </div>
    );
  }
}

InitiativeListItem.propTypes = {
  initiative: PropTypes.object,
};
